import request from '@/utils/request'

// 查询会议室类型
export function searchType(query) {
  return request({
    url: '/type/search',
    method: 'post',
    data: query
  })
}
// 新增
export function addType(params) {
  return request({
    url: '/type',
    method: 'post',
    data: params
  })
}
// 新增
export function editType(id, params) {
  return request({
    url: '/type/edit/' + id,
    method: 'post',
    data: params
  })
}
